import { BrowserRouter, Routes, Route } from 'react-router-dom'
import { useAuthContext } from './hooks/useAuthContext'

// pages
import Home from './pages/home/Home'

import Navbar from './components/Navbar'
import NavbarBottom from './components/NavbarBottom'
import Login from './pages/zugang/Login'
import Signup from './pages/zugang/Signup'


import Vision from './pages/about/Vision'
import Philosophy from './pages/about/Philosophy'
import History from './pages/about/History'
import Organization from './pages/team/Organization'
import Collaborators from './pages/team/Collaborators'
import EventsPast from './pages/interactions/EventsPast'
import Events from './pages/interactions/Events'
import Blog from './pages/publications/Blog'
import TransversalPaths from './pages/publications/TransversalPaths'
import Address from './pages/contact/Address'
import Impressum from './pages/impressum/Impressum'


function App() {
  const { authIsReady, user } = useAuthContext()

  return (
    <div className="App">
      { authIsReady && (
        <BrowserRouter>

          <Navbar />
          <div className="container">
            <Routes>
              <Route path='/' element={ <Home /> } />

              <Route path='/vision' element={ <Vision /> } />
              <Route path='/philosophy' element={ <Philosophy /> } />
              <Route path='/history' element={ <History /> } />

              <Route path='/organization' element={ <Organization /> } />
              <Route path='/collaborators' element={ <Collaborators /> } />
              <Route path='/address' element={ <Address /> } />
              <Route path='/impressum' element={ <Impressum /> } />

              <Route path='/events' element={ <Events /> } />
              <Route path='/eventspast' element={ <EventsPast /> } />

              <Route path='/transversalpaths' element={ <TransversalPaths /> } />
              <Route path='/blog' element={ <Blog /> } />

              <Route path='/login' element={user ? <Home /> : <Login />} />
              <Route path='/signup' element={user ? <Home/> : <Signup />} />

            </Routes>
          </div>
          <NavbarBottom />
        </BrowserRouter>
      )}
    </div>
  )
}

export default App;
